import {gql} from "@apollo/client";

export default gql`
  mutation removeManager($managerId: ID!, $employerId: ID!) {
    removeManager(managerId: $managerId, employerId: $employerId)
  }
`;
